import React from 'react';

/**
 * The 1080 x 1350 picture people can save and post. It is drawn off screen and turned into a PNG in the browser.
 * It shows only the stage, never an email, a name or an area score. Inline styles on purpose: html-to-image copies them faithfully.
 */
const FONT = "'WB Outfit', Outfit, system-ui, sans-serif";

const ShareCard = React.forwardRef(({ stage, url }, ref) => (
  <div aria-hidden="true" style={{ position: 'fixed', left: -10000, top: 0, pointerEvents: 'none' }}>
    <div
      ref={ref}
      style={{
        width: 1080, height: 1350, boxSizing: 'border-box', padding: 96, display: 'flex', flexDirection: 'column',
        justifyContent: 'space-between', fontFamily: FONT, color: '#2D4A4A',
        background: 'linear-gradient(160deg, #E8F5F5 0%, #C9E8E5 45%, #D9D1EA 100%)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
        <svg width="64" height="64" viewBox="0 0 24 24">
          <defs>
            <linearGradient id="qshare-g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#4AADA8" /><stop offset="1" stopColor="#A99CC8" /></linearGradient>
          </defs>
          <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" fill="url(#qshare-g)" />
        </svg>
        <span style={{ fontSize: 44, fontWeight: 600, letterSpacing: 6, color: '#3A9A95' }}>SIRATI</span>
      </div>

      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 190, lineHeight: 1.1 }}>{stage.emoji}</div>
        <div style={{ fontSize: 44, fontWeight: 500, color: '#565028', marginTop: 24 }}>My marriage readiness stage</div>
        <div style={{ fontSize: 96, fontWeight: 600, lineHeight: 1.1, marginTop: 28, color: '#2D4A4A' }}>{stage.name}</div>
        <div style={{ width: 160, height: 8, borderRadius: 8, margin: '48px auto 0', background: 'linear-gradient(90deg, #4AADA8, #A99CC8)' }} />
      </div>

      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 44, fontWeight: 600 }}>The Single Muslim Marriage Readiness Quiz</div>
        <div style={{ fontSize: 38, fontWeight: 500, color: '#565028', marginTop: 16 }}>Take it and see your stage</div>
        <div
          style={{
            display: 'inline-block', marginTop: 36, padding: '20px 44px', borderRadius: 999, fontSize: 38, fontWeight: 600,
            color: '#fff', background: 'linear-gradient(135deg, #4AADA8, #8A7BB3)',
          }}
        >
          {url}
        </div>
      </div>
    </div>
  </div>
));

ShareCard.displayName = 'ShareCard';

export default ShareCard;
